import { render, staticRenderFns } from "./chkOpenClass.vue?vue&type=template&id=2bc0dc1f&"
import script from "./chkOpenClass.vue?vue&type=script&lang=js&"
export * from "./chkOpenClass.vue?vue&type=script&lang=js&"
import style0 from "./chkOpenClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports